import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ArrowDownMedium from '@adv-mt/mt-svg-icons/lib/ArrowDownMedium.js'

const BASE_CLASS = 'mt-CardAdPrice-priceDrop'
const ICON_CLASS = `${BASE_CLASS}Icon`
const PERCENTAGE_CLASS = `${BASE_CLASS}Percentage`
const ORIGINAL_PRICE_CLASS = `${BASE_CLASS}OriginalPrice`

const CardAdPricePriceDrop = ({priceDropData}) => {
  const {i18n} = useContext(Context)

  const {originalPrice, percentage} = priceDropData || {}

  return priceDropData ? (
    <div className={BASE_CLASS}>
      <span className={ICON_CLASS}>
        <ArrowDownMedium size="small" />
      </span>
      <span className={PERCENTAGE_CLASS}>{percentage * -1}%</span>
      <span className={ORIGINAL_PRICE_CLASS}>{i18n.c(originalPrice)}</span>
    </div>
  ) : null
}

CardAdPricePriceDrop.propTypes = {
  priceDropData: PropTypes.object
}

export {CardAdPricePriceDrop}
